import LayoutCentered from '@/layout/LayoutCentered';

export default [
  {
    path: '/vacation-policy',
    component: LayoutCentered,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '',
        component: () => import('@/components/pages/vacations/vacation-policy.vue'),
      },
    ],
  },
];